var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThreejs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    viewBox: "0 0 226.77 226.77",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.964 4.2527)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "m63.02 200.61-43.213-174.94 173.23 49.874z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.39 50.612 21.591 87.496-86.567-24.945z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.91 125.03-10.724-43.465 43.008 12.346z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.458 38.153 10.724 43.465-43.008-12.346z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.47 62.93 10.724 43.465-43.008-12.346z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.915 125.06 10.724 43.465-43.008-12.346z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreejs);
export default __webpack_public_path__ + "static/media/threejs.34d1dab4caddf9c51437e9bafd282582.svg";
export { ForwardRef as ReactComponent };